<template>
  <svg aria-hidden="true" viewBox="0 0 1200 1200" ...attributes>
    <path
      fill="#63CC98"
      d="M600,440a60,60,0,1,1-60,60,60.068,60.068,0,0,1,60-60m0-40A100,100,0,1,0,700,500,100,100,0,0,0,600,400Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M810.007,704.232a17.541,17.541,0,0,1-25.473,15.621l-.283-.142c-24.505-12.252-53.354-21.938-85.746-28.789a544.342,544.342,0,0,0-216.995,0c-32.392,6.85-61.241,16.536-85.746,28.789l-.283.142a17.541,17.541,0,0,1-25.474-15.621v-5.384a17.671,17.671,0,0,1,9.842-15.877C433.975,656.4,508.156,640,590.007,640s156.032,16.4,210.158,42.97a17.671,17.671,0,0,1,9.842,15.877Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M600,278.763,300,385.905V700c0,165.686,134.314,300,300,300S900,865.686,900,700V385.905ZM839.584,801.192A260,260,0,0,1,340,700V414.095l260-92.857,260,92.857V700A258.335,258.335,0,0,1,839.584,801.192Z"
    ></path>
  </svg>
</template>
